<template>
  <a-card :bordered='false'>

    <!-- 查询区域 -->
    <div class='table-page-search-wrapper'>
      <a-form layout='inline' @keyup.enter.native='searchQuery'>
        <a-row :gutter='24'>

          <a-col :md='6' :sm='8'>
            <mtc-form-item label='tableHeader.titleCode'>
              <a-input :placeholder="$t('tableHeader.pleaseEnterTitleCode')" v-model='queryParam.code'></a-input>
            </mtc-form-item>
          </a-col>
          <a-col :md='6' :sm='8'>
            <mtc-form-item label='tableHeader.titleName'>
              <a-input :placeholder="$t('tableHeader.pleaseEnterTitleName')" v-model='queryParam.name'></a-input>
            </mtc-form-item>
          </a-col>
          <!--<template v-if="toggleSearchStatus">-->
          <a-col :md='6' :sm='8'>
            <mtc-form-item label='tableHeader.titleRank'>
              <j-dict-select-tag v-model='queryParam.postRank' :placeholder="$t('tableHeader.pleaseChooseTitleRank')" dictCode='position_rank' />
            </mtc-form-item>
          </a-col>

          <!--</template>-->
          <a-col :md='6' :sm='8'>
            <span style='float: left;overflow: hidden;' class='table-page-search-submitButtons'>
              <!--<a-button type="primary" @click="searchQuery" icon="search">{{$t('button.search')}}</a-button>-->
              <!--<a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{$t('button.reset')}}</a-button>-->
               <mtc-button @click='searchQuery' type='primary' icon='search' text='button.search'></mtc-button>
               <mtc-button @click='searchReset' type='primary' icon='reload' style='margin-left: 8px' text='button.reset'></mtc-button>
              <!--<a @click="handleToggleSearch" style="margin-left: 8px">-->
              <!--{{ toggleSearchStatus ? $t('tip.up') : $t('tip.down') }}-->
              <!--<a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>-->
              <!--</a>-->
            </span>
          </a-col>

        </a-row>
      </a-form>
    </div>

    <!-- 操作按钮区域 -->
    <div class='table-operator'>
      <!--<a-button @click="handleAdd" type="primary" icon="plus">{{$t('button.add')}}</a-button>-->
      <mtc-button @click='handleAdd' type='primary' icon='plus' text='button.add'></mtc-button>
      <!--<a-button type="primary" icon="download" @click="handleExportXls('职务表')">{{$t('button.export')}}</a-button>-->
      <mtc-button @click="handleExportXls('职务表')" type='primary' icon='download' text='button.export'></mtc-button>
      <a-upload name='file' :showUploadList='false' :multiple='false' :headers='tokenHeader' :action='importExcelUrl' @change='handleImportExcel'>
        <!--<a-button type="primary" icon="import">{{$t('button.import')}}</a-button>-->
        <mtc-button type='primary' icon='import' text='button.import'></mtc-button>
      </a-upload>
      <a-dropdown v-if='selectedRowKeys.length > 0'>
        <a-menu slot='overlay'>
          <a-menu-item key='1' @click='batchDel'>
            <a-icon type='delete' />
            {{ $t('button.delete') }}
          </a-menu-item>
        </a-menu>
        <!--<a-button style="margin-left: 8px"> {{$t('button.batchOperation')}}-->
        <!--<a-icon type="down"/>-->
        <!--</a-button>-->
        <mtc-button style='margin-left: 8px' text='button.batchOperation'></mtc-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class='ant-alert ant-alert-info' style='margin-bottom: 16px;'>
        <i class='anticon anticon-info-circle ant-alert-icon'></i> {{ $t('tip.selected') }} <a style='font-weight: 600'>{{ selectedRowKeys.length }}</a>{{ $t('tip.term') }}
        <a style='margin-left: 24px' @click='onClearSelected'>{{ $t('button.clear') }}</a>
      </div>

      <a-table
        ref='table'
        size='middle'
        bordered
        rowKey='id'
        :columns='columns'
        :dataSource='dataSource'
        :pagination='ipagination'
        :loading='loading'
        :rowSelection='{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}'
        @change='handleTableChange'>

        <template v-for='(item, index) in columns' :slot='item.slotName'>
          <!--<span :key="index">{{ $t(item.slotName) }}</span>-->
          <mtcHeader :key='index' :text='item.slotName' />
        </template>

        <span slot='action' slot-scope='text, record'>
          <!--<a @click="handleEdit(record)">{{$t('button.edit')}}</a>-->
          <mtc-button @click='handleEdit(record)' type='link' size='small' text='button.edit'></mtc-button>

          <a-divider type='vertical' />
          <a-dropdown>
            <!--<a class="ant-dropdown-link">{{$t('button.more')}} <a-icon type="down"/></a>-->
            <mtc-button type='link' size='small' text='button.more'></mtc-button>
            <a-menu slot='overlay'>
              <a-menu-item>
                <a-popconfirm :title="$t('tip.isDelete')" @confirm='() => handleDelete(record.id)'>
                  <!--<a>{{$t('button.delete')}}</a>-->
                   <mtc-button type='link' size='small' text='button.delete'></mtc-button>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
    </div>
    <!-- table区域-end -->

    <!-- 表单区域 -->
    <sysPosition-modal ref='modalForm' @ok='modalFormOk'></sysPosition-modal>
  </a-card>
</template>

<script>
import SysPositionModal from './modules/SysPositionModal'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import JDictSelectTag from '@/components/dict/JDictSelectTag'
import { MTC_AUTH } from '@api/servers'

export default {
  name: 'SysPositionList',
  mixins: [JeecgListMixin],
  components: {
    SysPositionModal,
    JDictSelectTag
  },
  data(){
    return {
      description: '职务表管理页面',
      // 表头
      columns: [
        {
          title: '#',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: function( t, r, index ){
            return parseInt(index) + 1
          }
        },
        {
          slotName: 'tableHeader.titleCode',
          // title: '职务编码',
          align: 'center',
          dataIndex: 'code',
          scopedSlots: { title: 'tableHeader.titleCode' }
        },
        {
          slotName: 'tableHeader.titleName',
          // title: '职务名称',
          align: 'center',
          dataIndex: 'name',
          scopedSlots: { title: 'tableHeader.titleName' }
        },
        {
          slotName: 'tableHeader.titleRank',
          // title: '职级',
          align: 'center',
          dataIndex: 'postRank_dictText',
          scopedSlots: { title: 'tableHeader.titleRank' }
        },
        // {
        //   title: '公司id',
        //   align: 'center',
        //   dataIndex: 'companyId'
        // },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          scopedSlots: { customRender: 'action' }
        }
      ],
      url: {
        list: `${ MTC_AUTH }sys/position/list`,
        delete: `${ MTC_AUTH }sys/position/delete`,
        deleteBatch: `${ MTC_AUTH }sys/position/deleteBatch`,
        exportXlsUrl: `${ MTC_AUTH }sys/position/exportXls`,
        importExcelUrl: `${ MTC_AUTH }sys/position/importExcel`
      }
    }
  },
  computed: {
    importExcelUrl: function(){
      return `${ window._CONFIG[ 'domianURL' ] }/${ this.url.importExcelUrl }`
    }
  }
}
</script>
<style scoped>
@import '~@assets/less/common.less'
</style>